import React from 'react';
import './App.css';

import TestDriveApp from './TestDriveApp';

const App = () => <TestDriveApp />;

export default App;